import Embed from './text-editor-embed';

class HashtagItalic extends Embed {
  static className = 'hashtag-italic';
}

HashtagItalic.blotName = 'hashtagItalic';

export default HashtagItalic;
